/** Domain string for email preview (explicit pick, else pattern default row, else nested defaultDomain). */
export function getPreviewDomainString(domains, domainId, pattern) {
  const row = domains?.find((d) => d.id === domainId);
  if (row?.domain) return row.domain;
  const defId = pattern?.default_domain_id || pattern?.defaultDomain?.id;
  const defRow = defId ? domains?.find((d) => d.id === defId) : null;
  if (defRow?.domain) return defRow.domain;
  return pattern?.defaultDomain?.domain || '';
}

/** UUID to send to the API (explicit pick must exist in list; else pattern default id if in list). */
export function getEffectiveDomainId(domains, domainId, pattern) {
  if (domainId && domains?.some((d) => d.id === domainId)) return domainId;
  const defId = pattern?.default_domain_id || pattern?.defaultDomain?.id;
  if (defId && domains?.some((d) => d.id === defId)) return defId;
  return '';
}

export function initialPatternAndDomainIds(patterns, domains) {
  const firstPat = patterns?.[0];
  if (!firstPat) {
    return {
      patternId: '',
      domainId: domains?.find((x) => x.is_primary)?.id || domains?.[0]?.id || '',
    };
  }
  const defId = firstPat.default_domain_id || firstPat.defaultDomain?.id;
  const domainId =
    defId && domains?.some((d) => d.id === defId)
      ? defId
      : domains?.find((x) => x.is_primary)?.id || domains?.[0]?.id || '';
  return { patternId: firstPat.id, domainId };
}
